import './App.css';
import theme from './components/ui/Theme';
import { ThemeProvider, responsiveFontSizes } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Home from './components/pages/Home';

function App() {

  return (
    <ThemeProvider theme={responsiveFontSizes(theme)}>
      <CssBaseline />
      <Container maxWidth='sm' align='center' justify='center'>
        <Home />
      </Container>
    </ThemeProvider>
  );
}

export default App;
